export function getBasePrice(apiData) {
	if (apiData) {
		return apiData.data.unit.base_price;
	}
}

export function getRoomData(roomId, apiData) {
	let roomData = {};
	if (apiData) {
		const rooms = apiData.data.visualisation.rooms;

		for (const key in rooms) {
			if (rooms[key].unreal_id == roomId) {
				roomData = { ...rooms[key] };
				for (const key in roomData.options) {
					roomData.options[key].isTabOpened = false;
				}
			}
		}
	} else {
		return null;
	}

	let isEmpty = Object.keys(roomData).length === 0;

	if (!isEmpty) {
		return roomData;
	} else {
		return null;
	}
}

export function getChangeObj(apiData) {
	const changeObj = [];
	const unitInfo = {};
	if (apiData) {
		const rooms = apiData.data.visualisation.rooms;

		for (let i = 0; i < rooms.length; i++) {
			let obj = {};
			obj.roomId = rooms[i].unreal_id;
			obj.roomName = rooms[i].label.de;
			obj.roomArea = rooms[i].area;
			obj.selectedChoice = [];
			for (let j = 0; j < rooms[i].options.length; j++) {
				let choiceObj = {};
				choiceObj.choice = {
					...rooms[i].options[j].choices.filter(
						(f) => f.is_standard == true
					)[0],
				};

				choiceObj.objName = rooms[i].options[j].unreal_id;
				choiceObj.objLabel = rooms[i].options[j].label.de;

				obj.selectedChoice[j] = choiceObj;
			}
			changeObj[i] = obj;
			unitInfo.unitArea = apiData.data.unit.area;
			unitInfo.unitName = apiData.data.unit.label.de;
			unitInfo.projectName = apiData.data.building.label.de;
			unitInfo.session = apiData.data.session;
		}
		return { changeObj, unitInfo };
	}

	return null;
}

export function findStartRoom(apiData) {
	let startRoomId = "00";
	let startFloorId = "00";

	if (apiData) {
		const levels = apiData.data.visualisation.maps.levels;

		for (const level of levels) {
			const rooms = level.teleports;
			for (const room of rooms) {
				if (room.start) {
					startRoomId = room.unreal_id.slice(-2);
					startFloorId = parseInt(level.unreal_id);
					break;
				}
			}
		}
	}
	return { startRoomId, startFloorId };
}
